import React from 'react';
import Hero from '../components/Hero';
import {
  ReferralSection, Testimonials, CTABand,
  TrustBar, PlatformFeatures, CoreServicesGrid, FAQSection,
} from '../components/Sections';
import ServicesForm from './ServicesForm';

const Home = () => {
  return (
    <div>
      <Hero />
      <TrustBar />
      <PlatformFeatures />
      <ServicesForm embedded />
      <ReferralSection />
      <CoreServicesGrid />

      {/* Keep this part unchanged as requested. */}
      <Testimonials />
      <FAQSection />
      <CTABand />
    </div>
  );
};

export default Home;
